<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;">
        <v-card class="overflow-hidden mx-1 mb-1">
          <v-card-title class="pa-5 pb-3">
            <p class="font-weight-bold">ユーザー登録</p>
          </v-card-title>
          <v-card-text class="pa-5 pt-0 font-weight-bold">
            <v-row>
              <v-col cols="5" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">ユーザ名</p>
              </v-col>
              <v-col cols="7">
                {{ RegisterInfo.name }}
              </v-col>
              <v-col cols="5" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">ユーザコード</p>
              </v-col>
              <v-col cols="7">
                {{ RegisterInfo.userCode }}
              </v-col>
              <v-col cols="5" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">メールアドレス</p>
              </v-col>
              <v-col cols="7">
                {{ RegisterInfo.email }}
              </v-col>
              <v-col cols="5" class="d-flex align-center">
                <p class="fs-normal greyBold--text mb-0">Password</p>
              </v-col>
              <v-col cols="7">
                {{ RegisterInfo.password }}
              </v-col>
              <v-col justify="end">
                <v-btn
                  :loading="loading"
                  @click="registerUser"
                  color="primary"
                  class="button-shadow ma-4"
                  width="30%"
                >仮登録をする</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "SignupConfirm",
  data() {
    return {
      loading: false,
      height: window.innerHeight,
    };
  },
  computed: {
    RegisterInfo: function() {
      return this.$store.getters['signup/RegisterInfo']
    }
  },
  methods: {
    registerUser: async function () {
      this.loading = true
      await this.$store.dispatch('signup/create', this.RegisterInfo)
      .then(() => {
        this.$router.push('/thank_you')
      }).catch(error => {
        this.$swal('エラー', error, 'error')
        this.loading = false
      })
    },
  }
};
</script>